// @flow
import PageNode from 'components/page/PageNode';
import { connect } from 'react-redux';
import { fetchPageNode, fetchPageList, fetchPageDetailPreview } from 'actions/pageActions';
import { fetchPartenaire } from 'actions/partenaireActions';

import type { DispatchProps, StateProps } from 'components/page/PageNode';
import type { DispatchType, StateType } from 'types/Actions';

import { withRouter } from 'react-router-dom';

export default withRouter(
  connect(
    (state: StateType): StateProps => ({
      liste_enfants: state.pageNodeState.pageNode.liste_enfants ?
        state.pageNodeState.pageNode.liste_enfants : state.pageDetailPreviewState.liste_enfants,
      sidebar_content: state.pageNodeState.pageNode.sidebar_content,
      pageDetailSidebar: state.pageDetailState.sidebar_content.length > 0 ? 
        state.pageDetailState.sidebar_content : state.pageDetailPreviewState.sidebar_content,
      preview: state.pageDetailPreviewState,
      pageListSidebar: state.pageListState.sidebar_content,
      contentNode: state.pageNodeState.pageNode.content.length > 0 ? state.pageNodeState.pageNode.content : state.pageDetailPreviewState.content,
      status: state.pageNodeState.status,
      statusList: state.pageListState.status,
      statusPreview: state.pageDetailPreviewState.status,
      statusPartner: state.partenaireState.partenaireStatus,
      template: state.pageNodeState.pageNode.template,
      templateDetail: state.pageDetailState.template,
      templateList: state.pageListState.template,
      templatePreview: state.pageDetailPreviewState.template,
      redirection: state.pageNodeState.pageNode.redirection,
      partenaire: state.partenaireState.partenaire,
      pratiques_structure: state.pageNodeState.pageNode.pratiques_structure,
      organization: state.settingsState.title,
      club: state.settingsState.structure,
    }),
    (dispatch: DispatchType): DispatchProps => ({
      fetchPageNode: (slug: string) => dispatch(fetchPageNode(slug)),
      fetchPageList: (slug: string) => dispatch(fetchPageList(slug)),
      fetchPartenaire: (slug: string) => dispatch(fetchPartenaire(slug)),
      fetchPageDetailPreview: (id: number) => dispatch(fetchPageDetailPreview(id)),
    })
  )(PageNode)
);
